import React, { useState } from 'react';
import { SurveyPanel } from '../../components/survey/SurveyPanel';
import { Modal, Typography } from '@thingsw/pitta-design-system';
import { useTranslation } from 'react-i18next';
import { SemanticDarkColors, sendMessageBack } from '@thingsw/pitta-modules';
import { useSelector } from 'react-redux';
import { RootState } from '../../features/store';
import { THEME } from '../../features/Theme/slice';
import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  cancelBtn: {
    width: '100%',
    backgroundColor: (props: any) =>
      props.color === 'dark'
        ? SemanticDarkColors.primary['1']
        : props.colors.primary['0'],
    color: (props: any) => props.colors.primary['1'],
    '&:active': {
      color: (props: any) => props.colors.primary['1'],
    },
  },
}));

export const SurveyScreen = () => {
  const { t } = useTranslation();
  const { colors, color } = useSelector((state: RootState) => state[THEME]);
  const [isOpenSkipModal, setIsOpenSkipModal] = useState(false);
  const classes = useStyles({ color, colors });
  return (
    <>
      <SurveyPanel onSkip={() => setIsOpenSkipModal(true)} />;
      <Modal
        open={isOpenSkipModal}
        LButton={t('Cancel')}
        fullWidthBtn
        RButton={t('Skip')}
        LButtonClassName={classes.cancelBtn}
        content={
          <Typography htmlColor={colors.primary['1']} variant='H5'>
            {t('Would you like to skip?')}
          </Typography>
        }
        onClickAway={() => {
          setIsOpenSkipModal(false);
        }}
        onClickNegative={() => {
          setIsOpenSkipModal(false);
        }}
        onClickPositive={() => {
          // 설문 종료 후 웹뷰어 화면으로 이동
          setIsOpenSkipModal(false);
          sendMessageBack();
        }}
      />
    </>
  );
};
